import React from 'react'
import styled from 'styled-components'
import { JobType } from 'generated/graphql'
import { PAGE_SIZE } from '@app.feature/coverletter/coverletter.write/module/constant'
import { useDutyModalStore } from '../../../store/dutyModal'

const formatJobType: {
  [jobType in JobType]: string
} = {
  [JobType.NEW]: '신입',
  [JobType.INTERN]: '인턴',
  [JobType.EXPERIENCED]: '경력',
  [JobType.CONTRACT]: '계약',
}

const JobTypeDropdown: React.FC = () => {
  const variables = useDutyModalStore((store) => store.variables)
  const setVariables = useDutyModalStore((store) => store.setVariables)

  const handleAllItemClick = () => {
    setVariables({
      ...variables,
      filterBy: {
        ...variables?.filterBy,
        jobType: undefined,
      },
      pagination: {
        ...variables?.pagination,
        page: 1,
        pageSize: PAGE_SIZE,
      },
    })
  }
  const handleJobTypeItemClick = (key: JobType) => {
    setVariables({
      ...variables,
      filterBy: {
        ...variables?.filterBy,
        jobType: key,
      },
      pagination: {
        ...variables?.pagination,
        page: 1,
        pageSize: PAGE_SIZE,
      },
    })
  }

  return (
    <StyledWrapper>
      <div className="dropdown-item" onClick={handleAllItemClick}>
        전체
      </div>
      {Object.keys(formatJobType).map((key, index) => (
        <div
          className="dropdown-item"
          key={`dropdown-item-${index}`}
          onClick={() => handleJobTypeItemClick(key as JobType)}
        >
          {formatJobType[key]}
        </div>
      ))}
    </StyledWrapper>
  )
}

export default JobTypeDropdown

const StyledWrapper = styled.div`
  padding: 6px 0;
  width: 115px;
  position: absolute;
  top: calc(100% + 5px);
  left: calc(50% - 7px);
  transform: translateX(-50%);
  background-color: white;
  border: 1px solid #cccccc;
  z-index: 10;
  border-radius: 5px;
  cursor: pointer;
  .dropdown-item {
    padding: 8px 16px;
    color: #333333;
    font-size: 12px;
    height: 32px;
    text-align: start;
    &:hover {
      background-color: #f8f8f8;
    }
  }
`
